import { useCurrentProject } from 'providers/LiteProjectProvider';
import React from 'react';
import ProjectDetailHeaderContent from 'views/components/Header/ProjectDetailHeaderContent';

const ProjectDetailViewHeader = ({ user, onChangePhase, onReorderPhases, onOpenPhasesModals }) => {
  const { selectedPhaseId, project, isTemplate, template } = useCurrentProject();

  return (
    <ProjectDetailHeaderContent
      user={user}
      project={project}
      isTemplate={isTemplate}
      template={template}
      selectedPhaseId={selectedPhaseId}
      onChangePhase={onChangePhase}
      onReorderPhases={onReorderPhases}
      onOpenPhasesModals={onOpenPhasesModals}
    />
  );
};

export default ProjectDetailViewHeader;
